import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { SERVICES, BUSINESS } from "@/lib/constants";

export default function Services() {
  return (
    <div data-testid="services-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-black">Our Services</h1>
        <p className="mt-4 text-xl text-gray-700">We defend all major Alberta traffic charges. Click any service to learn more.</p>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s) => (
          <Link
            key={s.slug}
            to={`/services/${s.slug}`}
            data-testid={`service-link-${s.slug}`}
            className="bg-white border border-slate-200 rounded-lg p-6 hover:shadow-md hover:border-gold transition-all"
          >
            <h2 className="font-heading text-xl font-bold text-navy">{s.name}</h2>
            <p className="mt-2 text-gray-700">{s.description}</p>
            <div className="mt-4 inline-flex items-center gap-2 text-navy font-semibold">
              Learn more <ArrowRight className="w-4 h-4" />
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-16 bg-white border-t border-slate-200 pt-12 text-center">
        <h2 className="font-heading text-3xl font-bold text-black">Not sure which applies?</h2>
        <p className="mt-3 text-lg text-gray-700">Call us — we'll guide you through it in plain English.</p>
        <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary mt-6 inline-flex" data-testid="services-call-btn">
          <Phone className="w-5 h-5" /> Call {BUSINESS.phone}
        </a>
      </div>
    </div>
  );
}
